import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { config } from '../config';
import { Output, EventEmitter } from '@angular/core';
import { preferencesLists } from '../_models/staticArray'
// import undefined = require('firebase/empty-import');





@Injectable({
  providedIn: 'root'
})
export class LoginService {

  @Output() userRole: EventEmitter<any> = new EventEmitter<any>();
  @Output() userProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() userToken: EventEmitter<any> = new EventEmitter<any>();
  @Output() userRolesSet: EventEmitter<any> = new EventEmitter<any>();
  @Output() modulesSet: EventEmitter<any> = new EventEmitter<any>();

  private loggedInUser = new Subject<any>();
  private currentUserSubject: BehaviorSubject<any>;
  private userRoleSubject: BehaviorSubject<any>;
  private userPermissionSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  public userRoles: Observable<any>
  returnUrl;
  tempUser: any;
  roles = {};
  modules: any = {};


  constructor(public activeRoute: ActivatedRoute, private http: HttpClient, private router: Router) {



    console.log('localStorage', localStorage.getItem('currentUser'));
    if (localStorage.getItem('currentUser') != null) {
      console.log('Inside IF-----------');
      this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
      this.userRoleSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('userRoles')))
      this.userPermissionSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('module')))
    } else {
      this.currentUserSubject = new BehaviorSubject<any>(localStorage.getItem('currentUser'));
      this.userRoleSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('userRoles')))
      this.userPermissionSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('module')))
    }

    this.currentUser = this.currentUserSubject.asObservable();
    this.userRoles = this.userRoleSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public get userRolesValue(): any {
    return this.userRoleSubject.value
  }

  public get userPermissionValue(): any {
    return this.userPermissionSubject.value
  }

  sendLoggedInUserToAppUser(jobs) {
    console.log("response of jobs", jobs);

    this.loggedInUser.next({ jobs })
  }
  getLoggedInUser(): Observable<any> {
    return this.loggedInUser.asObservable();
  }



  login(data: any, routename, token): Observable<any> {
    data.recaptchaToken = token;
    console.log("Adding clients", data);
    console.log('Route name:', routename);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;

      this.http.post(config.baseApiUrl + "" + routename + "/login", data).subscribe((res: any) => {
        console.log("res of login user", res);

        localStorage.setItem('token', res.token);
        localStorage.setItem('currentUser', JSON.stringify(res.profile));
        let tempmodule: any = JSON.stringify(res.profile)
        this.setModules()
        this.setUserRoles()
        // localStorage.setItem('preferences', JSON.stringify(preferencesLists))
        if (res.userRole.includes('admin') && res.preferences.length) this.setPreferences(res.preferences)
        this.currentUserSubject.next(res.profile);
        this.loggedInUser.next({ currentUser: res.profile })
        this.userRole.emit(res.userRole);
        this.userProfile.emit(res.profile);
        this.userToken.emit(res.token);
        observer.next(res.profile);
        observer.complete();
        return res.profile;
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });

  }

  updatePasswordPolicyAdmin(data): Observable<any> {
    console.log("reset password", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "admin/update-password", data).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });
  }

  updatePasswordPolicy(data): Observable<any> {
    console.log("reset password", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "user/update-password", data).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });
  }


  setUserRoles() {
    console.warn("SETTING ROLE")
    this.roles = {}
    let tempUser = JSON.parse(localStorage.getItem('currentUser'))
    if (tempUser && tempUser.userRole) {
      console.warn("SETTING ROLE IN IF")
      if (tempUser.userRole && tempUser.userRole.length == 0) {
        this.roles = {
          isStaff: true
        }
        localStorage.setItem('userRoles', JSON.stringify(this.roles));
        this.userRolesSet.emit('done')
      }
      tempUser.userRole.forEach(el => {
        if (el == 'admin') this.roles['isAdmin'] = true
        if (el == 'trainer') this.roles['isTrainer'] = true
        if (el == 'mp') this.roles['isMp'] = true
        if (el == 'client') this.roles['isClient'] = true
        if (el == 'learner') this.roles['isLearner'] = true
        if (el == 'IQA') this.roles['isIQA'] = true
        if (el == 'superAdmin') this.roles['isSuperAdmin'] = true
        if (el == 'incidentUser') this.roles['isIncidentUser'] = true
        if (el == 'operative') this.roles['isOperative'] = true
        if (el == 'assetManager') this.roles['isAssetManager'] = true
        if (el == 'manager') this.roles['isManager'] = true
      })
      localStorage.setItem('userRoles', JSON.stringify(this.roles));
      this.userRolesSet.emit('done')
      this.userRoleSubject.next(this.roles)
    } else {
      this.roles = {}
      console.log("when it is logout", this.roles);
      this.userRoleSubject.next(this.roles)
    }

  }

  /**
   * @param data set preferences for login user in localstorage
   */
  setPreferences(data) {
    console.log("preferencesLists", data);
    localStorage.setItem('preferences', JSON.stringify(data))
  }

  logout(userId?, stateUrl?: Boolean) {
    console.log('Logout is called', userId);
    this.tempUser = localStorage.currentUser ? JSON.parse(localStorage.currentUser) : null
    // localStorage.removeItem('module')
    this.modules = {}
    this.currentUserSubject.next(null);
    this.userRole.emit(null);
    this.userProfile.emit(null);
    this.setUserRoles()
    // this.userRoleSubject.next({})
    // console.log("this.tempUser['userRole']", this.tempUser['userRole'][0])
    if (this.tempUser) {
      switch (this.tempUser['userRole'][0]) {
        case 'admin':
          if (stateUrl) {
            this.router.navigate(['/login/admin'], { queryParams: { returnUrl: this.router.url } });
          } else {
            this.router.navigate(['/login/admin']);
          }
          localStorage.clear();
          break;
        default:
          if (stateUrl) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
          } else {
            this.router.navigate(['/login']);
          }
          localStorage.clear();
          break;
      }
    }

    $(document).ready(function () {
      $(".sidebar").hide();
      $("#topnav").hide();
    });
    // return new Observable<any>((observer) => {
    var that = this;
    if (userId != undefined) {

      this.http.delete(config.baseApiUrl + "notification/remove-token?userId=" + userId).subscribe((res: any) => {
        console.log("response of token removed", res);

      })
    }

  }
  removeUser() {
    localStorage.removeItem('userRoles')
    localStorage.removeItem('currentUser')
    $(document).ready(function () {
      $(".sidebar").hide();
      $("#topnav").hide();
    });
  }


  forgotPassword(data: any, routename): Observable<any> {
    console.log("forgotpassword", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "" + data.user + "/forgot-password", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });
  }

  resetPassword(data: any, routename): Observable<any> {
    console.log("reset password", data, routename);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "" + routename + "/reset-password", data).subscribe((res: any) => {


        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });

  }



  /**
   * @param data 
   * @returns Set the current user preferences
   */
  setUserPreferences(data: any): Observable<any> {
    console.log("reset password", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + 'user' + "/user-preferences", data).subscribe((res: any) => {
        this.setPreferences(res.data.preferences)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });

  }


  superAdmin(data) {
    localStorage.clear()
    console.log('data', JSON.parse(data).user)
    //JSON.parse(data).user['modules'] = JSON.parse(JSON.parse(data).modules)
    let roles = {
      isAdmin: true
    };
    localStorage.setItem('token', JSON.parse(data).token)
    localStorage.setItem('currentUser', JSON.stringify(JSON.parse(data).user));
    localStorage.setItem('userRoles', JSON.stringify(roles))
    // localStorage.setItem('module')
    this.currentUserSubject.next(JSON.parse(data).user);

    this.userRole.emit(["admin"]);
    this.userProfile.emit(JSON.stringify(JSON.parse(data).user));
    this.userToken.emit(JSON.parse(data).token);
    this.userRolesSet.emit('done')
    this.router.navigate(['/dashboard'])
    this.userRoleSubject.next(roles)

    $(document).ready(function () {
      $(".sidebar").show();
      $("#topnav").show();
    });
    this.setModules()
  }




  setModules() {
    // console.log("data", data);
    let data = (JSON.parse(localStorage.getItem('currentUser')));
    console.log("this is the login data", data);
    console.log("before modules data", this.modules);
    data.modules.forEach(element => {
      console.log("main element", element);
      if (element.clientValue == 'staff') {
        console.log("single element", element);

        let obj = {
          isStaff: true
        }
        this.modules['isStaff'] = true
      }
      if (element.clientValue == 'documents') {
        console.log("second element", element);
        let obj = {
          isMyDocs: true
        }
        this.modules['isMyDocs'] = true
      }
      if (element.clientValue == 'timesheet') {
        console.log("third", element);
        let obj = {
          isTimesheet: true
        }
        this.modules['isTimesheet'] = true
      }
      if (element.clientValue == 'trainingJob') {
        console.log("call this or not", element);
        let obj = {
          isTrainingJob: true
        }
        this.modules['isTrainingJob'] = true
        console.log("module clientValue", this.modules);
      }
      if (element.clientValue == 'medicalJob') {
        console.log("fifth element", element);
        let obj = {
          isMpJob: true
        }
        this.modules['isMpJob'] = true
      }
      if (element.clientValue == 'inductions') {
        console.log("fifth element", element);
        let obj = {
          isInductions: true
        }
        this.modules['isInductions'] = true
      }
      if (element.clientValue == 'accident') {
        console.log("fifth element", element);
        this.modules['isAccident'] = true
      }
      if (element.clientValue == 'asset') {
        console.log("fifth element", element);
        this.modules['isAsset'] = true
      }
      if (element.clientValue == 'asset') {
        console.log("fifth element", element);
        this.modules['isAsset'] = true
      }
      if (element.clientValue == 'labourjob') this.modules['isLabourjob'] = true
      if (element.clientValue == 'client') this.modules['isClient'] = true
    });
    this.userPermissionSubject.next('done')
    localStorage.setItem('module', JSON.stringify(this.modules))
    this.modulesSet.emit('done')
    console.log("this is the final list of modules", this.modules);
    this.userPermissionSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('module')))
  }


  // Get dashboard count according to module wise
  getDashboardCount(): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "admin/count-details").subscribe((res: any) => {
        console.log("Get Jobs... :11111111 ", res);
        observer.next(res.data);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      }, () => {
        observer.complete();
      });
    })
  }


}




// let module = {
//   "isTrainingJob": true,
//   "isStaff": true
// }